import { Component, ChangeDetectionStrategy, OnInit } from '@angular/core';
import { AppState } from '@root/app-state.module';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { PointOfInterestProperty } from '@root/search/models/map.constants';
import { PointOfInterestConfig, SidePanelTab, SidePanelView } from '@store/search-board/search-board.model';
import { AddPointOfInterestProperty, RemovePointOfInterestProperty } from '@store/search-board/search-board.actions';
import {
  selectPointsOfInterestConfig,
  selectSelectedPointsOfInterestProperty, selectSidePanelState
} from '@store/search-board/search-board.selector';
import { MixpanelService } from '@shared/services/mixpanel.service';
import { SearchMixpanelUtil } from '@root/search/search-mixpanel-util';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  selector: 'rlst-map-points-of-interest',
  templateUrl: './map-points-of-interest.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MapPointsOfInterestComponent implements OnInit {

  public pointOfInterest$: Observable<Array<PointOfInterestConfig>>;
  public selectedPointsOfInterest$: Observable<Array<PointOfInterestProperty>>;

  private sidePanelTabOpened: SidePanelTab;
  private readonly searchMixpanelUtil: SearchMixpanelUtil = new SearchMixpanelUtil(this.store$);

  constructor(private readonly store$: Store<AppState>,
              private readonly mixpanelService: MixpanelService) {
  }

  ngOnInit(): void {
    this.pointOfInterest$ = this.store$.pipe(select(selectPointsOfInterestConfig));
    this.selectedPointsOfInterest$ = this.store$.pipe(select(selectSelectedPointsOfInterestProperty));

    this.store$
      .pipe(
        select(selectSidePanelState),
        untilDestroyed(this)
      )
      .subscribe((sidePanelView: SidePanelView) => {
        this.sidePanelTabOpened = sidePanelView.sidePanelTabOpened;
      });
  }

  togglePointOfInterest(event: Event, pointOfInterest: PointOfInterestProperty): void {
    const target = event.target as HTMLInputElement;

    if (target.checked) {
      this.logMapBoundariesMixPanel('Search - Point Of Interest Added', pointOfInterest.toString());
    } else {
      this.logMapBoundariesMixPanel('Search - Point Of Interest Removed', pointOfInterest.toString());
    }

    this.store$.dispatch(target.checked ?
      new AddPointOfInterestProperty(pointOfInterest) :
      new RemovePointOfInterestProperty(pointOfInterest)
    );
  }

  isChecked(selectedPoints: Array<PointOfInterestProperty>, key: string): boolean {
    return selectedPoints.includes(key as PointOfInterestProperty);
  }

  private logMapBoundariesMixPanel(eventId: string, pointOfInterest: string) {
    this.searchMixpanelUtil.setupMixPanelItems(this.sidePanelTabOpened);

    this.mixpanelService.track(eventId, {
      countyList: this.searchMixpanelUtil.countyList,
      searchType: this.sidePanelTabOpened,
      isSavedSearch: (this.sidePanelTabOpened === 'quickSearch') ? false :
        this.searchMixpanelUtil.selectedSearch !== 'My Search Default',
      searchParameters: this.searchMixpanelUtil.searchFieldNames.join('; '),
      pointOfInterest: pointOfInterest,
      numberOfResults: this.searchMixpanelUtil.totalSearchRecords
    });
  }
}
